import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_AUTH_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  REFRESH_TOKEN_SUCCESS
} from "../../constants/ActionTypes";
import * as utils from "utils"


const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: null ,
  tokenInfo: null,
  loggedTime: null
};


const AuthReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload.userInfo,
        tokenInfo: action.payload.tokenInfo,
        loggedTime: utils.getCurrentTimeInSecond()
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        tokenInfo: null,
        initURL: '/',
        loader: false,
        loggedTime: null
      }
    }
    case SHOW_AUTH_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        loader: false,
        tokenInfo: action.payload
      }
    }

    default:
      return state;
  }
}

export default AuthReducer;
